import React from "react";
import { PiDownloadSimpleBold } from "react-icons/pi";
import Button from "../../common/Button";

export const ShowDownload = ({ modalOpen, setModalOpen, folderData }) => {
  const handleDownload = (fileUrl, fileName) => {
    if (fileUrl) {
      fileUrl = fileUrl.replace(/%20/g, " ");

      const cleanedFileName = fileName.replace(/^\d+_/, "");

      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", cleanedFileName || "download");
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      console.error("No valid file URL found.");
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    modalOpen && (
      <div
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50"
        onClick={handleCloseModal}
      >
        <div
          className="bg-white rounded-md shadow-lg px-6 py-2 pb-6 w-full max-w-lg m-5"
          onClick={(e) => e.stopPropagation()} // Prevent closing modal when clicking inside
        >
          <div className="flex justify-between items-center ">
            <h3 className="text-xl font-semibold"></h3>
            <button
              onClick={handleCloseModal}
              className="text-gray-500 text-2xl font-bold hover:scale-125 duration-300"
            >
              &times;
            </button>
          </div>
          <div className="space-y-2 text-center">
            <h4 className="font-bold text-xl">{folderData.title}</h4>
            <p className="text-gray-600">
              Description: {folderData.description}
            </p>
            <p>
              Uploaded on: {new Date(folderData.createdAt).getFullYear()}/
              {(new Date(folderData.createdAt).getMonth() + 1)
                .toString()
                .padStart(2, "0")}
              /
              {new Date(folderData.createdAt)
                .getDate()
                .toString()
                .padStart(2, "0")}
            </p>
          </div>

          {/* Scrollable area for files and additional details */}
          <div className="space-y-4 pt-4 overflow-y-auto max-h-96 px-4 py-2">
            {folderData.files && folderData.files.length > 0 ? (
              folderData.files.map((file, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center border-2 shadow-md p-2 rounded-md hover:scale-105 duration-300 "
                >
                  <div className="">
                    {/* Display file name */}
                    {file.filename
                      ? file.filename
                          .split(".") // Split by dot to separate the extension
                          .slice(0, -1) // Remove the last part (file extension)
                          .join(".") // Join back if needed (for cases like multiple dots in the name)
                          .replace(/%20/g, " ") // Replace "%20" with spaces
                          .replace(/_20/g, " ") // Replace "_20" with spaces
                      : ""}
                    {/* {file.filename} */}
                  </div>
                  <Button
                    onClick={
                      () => handleDownload(file.publicUrl, file.filename) // Pass the URL and filename correctly
                    }
                    className="px-4 py-2 flex items-center justify-center"
                  >
                    <PiDownloadSimpleBold className="p-1 text-3xl" />
                    Download
                  </Button>
                </div>
              ))
            ) : (
              <p className="text-gray-600">No files in this folder.</p>
            )}
          </div>
        </div>
      </div>
    )
  );
};
